import { gql } from 'apollo-angular';

import { Invoice } from 'app/shared/apollo/queries/invoice';

const dataAttributesLight = `
      id
      fakturaNr
      type
      kreditfaktura
      invoiceReminder
      sumBox
      momsBox
      rotBox
      totalBox
      bruttoBox
      status
      statusRot
      rotYear
      projectInvoiceHistory
      interest
      sended
      created
      companyId
      projectId
      externalFakturaNr
      ovrigt
      fakturaAdress
      fakturaOrgNr
      typeInvoice
      typeLayout
      description
      companyName
      companyAdress
      companyAddressRow2
      companyTlfn
      companyFax
      companyMail
      companyOrgNr
      companyWebb
      companyBankGiro
      companyPostGiro
      companyIban
      companyBicSwift
      fdatum
      ffdatum
      importedFrom
      importedFromId
      payDate
      our_reference
      your_reference
      your_order_nr
      contact_id
      balance
      invoiceFee
      taxReductionWork
      taxReductionMaterial
      paymentPassed_PreInvoiceTypeHyperion
      hasInvoiceBase_PreInvoiceTypeHyperion
      isLegacyTaxReductionInvoice
      projects_PreInvoiceTypeHyperion {
        edges {
          node {
            id
            trueId
            mark
          }
        }
      }
      contact {
        id
        trueId
        address
        address2
        city
        cityCode
        name
        mail
        mailInvoice
        mobilePhone
        orderBuisnessName
        orgNr
        phone
        contactType
        parentCrediflow {
          id
          isAccepted
        }
      }
    `;

export const CompanyInvoiceFirst = gql`
query CompanyInvoiceFirst ($first: Int, $offset: Int) {
  company  {
    id
    invoices (first: $first, offset: $offset) {
      totalCount
      edges {
        node {
          ${dataAttributesLight}
        }
      }
    }
  }
}`;
export const CompanyInvoiceLast = gql`
query CompanyInvoiceLast ($last: Int, $offset: Int) {
  company  {
    id
    invoices (last: $last, offset: $offset) {
      totalCount
      edges {
        node {
          ${dataAttributesLight}
        }
      }
    }
  }
}`;
export const CompanyInvoiceAll = gql`
query CompanyInvoiceAll {
  company  {
    id
    invoices {
      totalCount
      edges {
        node {
          ${dataAttributesLight}
        }
      }
    }
  }
}`;

export const CompanyInvoicesByIds = gql`
query fetchCompanyInvoicesByIds($multiId: [Int]) {
  company {
    id
    invoices: invociesAndSupplierInvoices(multiId: $multiId) {
      totalCount
      edges {
        node {
          ${dataAttributesLight}
        }
      }
    }
  }
}`;

export const RotPersonsByProjectId = gql`
  query getContactPersonsByProjectId($id: Int) {
    project(id: $id) {
      id
      rots {
        edges {
          node {
            id
            personalNumber
            nameOfProperty
            housingAssociationOrgNumber
            apartmentDesignation
            customerWantedWorkAmount
            name
          }
        }
      }
    }
  }
`;
export const getFull = gql`
query getFullInvoice($id: Int) {
  company {
    id
    betalningsvillkor
    invoices: invociesAndSupplierInvoices(id: $id) {
      totalCount
      edges {
        node {

          ${dataAttributesLight}

          projectsTroughRows {
            edges {
              node {
                id
                mark
                trueId
              }
            }
          }

          days (first:-1) {
            totalCount
          }
          products {
            totalCount
            edges {
              node {
                productId
                artnr
                benamning
              }
            }
          }
          invoiceRotRequestingsExtra {
            ...HouseWorkTypeCosts
          }
          invoiceRotRequestings {
            edges {
              node {
                id
                personalNumber
                nameOfProperty
                housingAssociationOrgNumber
                apartmentDesignation
                customerWantedWorkAmount
                wantedWorkAmount
                name
              }
            }
          }
          invoiceSourceDocuments_PreInvoiceTypeHyperion {
            edges {
              node {
                url
                label
              }
            }
          }
          rows {
            edges {
              node {
                id
                typeId
                benamning
                antal
                enhet
                project_id
                product_id
                apris
                discount
                tax
                pris
                arbetskostnad
                houseWorkHoursToReport
                houseWorkType
                accountingPlanAccountId
                project{
                  id
                  trueId
                  mark
                }
              }
            }
          }
        }
      }
    }
  }
}
${Invoice.fragments.houseWorkTypeCosts}
`;
